import { styled } from '@mui/material';
import { IconButton } from '@sdb/planning-ui';

import { protocolIconSize } from '../../Protocols.styles';

/** The pencil sits in line with the title, its icon a touch larger than the title text */
export const EditButton = styled(IconButton)(({ theme }) => ({
  '& svg': protocolIconSize(theme)
}));
